import { Drawer, Typography, Tabs } from "antd";

import { useAppDispatch, useAppSelector } from "store/hook";
import DeviceCharts from "Components/Report/OnDemand/chartsList/DeviceCharts";
import { deviceOptions } from "./Filter";
import { Fragment } from "react";
import {
  StateSIM,
  StateGPSF,
  StatesDNSF,
  StateConnectionF,
  IdentityTableF,
} from "Components/Topology/Device/DeviceTableF_StateModalF";
import { useDeviceIdentityByID, useDeviceStatusByID } from "Components/Dashboard/queries";

import { setOnViewDevice, setOnViewDevice_Period } from "Components/Report/reportSlice";

const { TabPane } = Tabs;

const { Text } = Typography;

const DeviceChartsDrawer = () => {
  const disp = useAppDispatch();

  const { onViewingDevice } = useAppSelector((state) => state.report);

  const { data: deviceStatusByID } = useDeviceStatusByID(onViewingDevice, Boolean(onViewingDevice));

  const { data: deviceIdentityByID } = useDeviceIdentityByID(onViewingDevice, Boolean(onViewingDevice));
  // const loading = deviceStatusFetching || deviceIdentityFetching;

  return (
    <Drawer
      title={<Text>{onViewingDevice}</Text>}
      width={"75%"}
      onClose={() => {
        disp(setOnViewDevice(undefined));
        disp(setOnViewDevice_Period(undefined));
      }}
      visible={Boolean(onViewingDevice)}
      destroyOnClose
    >
      <Tabs defaultActiveKey="1">
        <TabPane tab="Chart" key="1">
          <DeviceCharts
            device={onViewingDevice ? [onViewingDevice] : []}
            parameter={deviceOptions.map((o) => o.value)}
          />
        </TabPane>

        {deviceStatusByID?.status && (
          <Fragment>
            <TabPane tab="Connection" key="connection">
              <StateConnectionF deviceStatusByID={deviceStatusByID} />
            </TabPane>
            <TabPane tab="SIM" key="sim">
              <StateSIM deviceStatusByID={deviceStatusByID} />
            </TabPane>
            <TabPane tab="GPS" key="gps">
              <StateGPSF deviceStatusByID={deviceStatusByID} />
            </TabPane>
            <TabPane tab="DNS" key="dns">
              <StatesDNSF deviceStatusByID={deviceStatusByID} />
            </TabPane>
          </Fragment>
        )}
        {deviceIdentityByID && (
          <TabPane tab="Identity" key="identity">
            <IdentityTableF deviceStatusByID={deviceStatusByID} deviceIdentityByID={deviceIdentityByID} />
          </TabPane>
        )}
      </Tabs>
    </Drawer>
  );
};

export default DeviceChartsDrawer;
